module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage addrule_edit"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": true,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "负责人",
      "prop": "fuzerenList"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openFzr
    }
  }, [_vm._v("添加负责人")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "data": _vm.params.fuzerenList,
      "header-cell-style": {
        background: '#F3F4F7',
        color: '#555'
      },
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "lawyerName",
      "label": "律师"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lawyerPost",
      "label": "职务",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "操作",
      "header-align": "center",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.delFzr(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成员",
      "prop": "committeeMemberList"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "搜索律师",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.selectChange1,
      "visible-change": _vm.visibleChange1
    },
    model: {
      value: (_vm.searchValue1),
      callback: function($$v) {
        _vm.searchValue1 = $$v
      },
      expression: "searchValue1"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item
      }
    })
  })), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "data": _vm.params.committeeMemberList,
      "header-cell-style": {
        background: '#F3F4F7',
        color: '#555'
      },
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "lawyerName",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cellphone",
      "label": "手机号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certificateNo",
      "label": "执业证号",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "260",
      "label": "操作",
      "header-align": "center",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.delMember(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增负责人",
      "visible": _vm.dialogFzrVisible,
      "width": "360px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFzrVisible = $event
      },
      "closed": _vm.closedDialog
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.formFzr
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "律师名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "搜索律师",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.selectChange2
    },
    model: {
      value: (_vm.searchValue2),
      callback: function($$v) {
        _vm.searchValue2 = $$v
      },
      expression: "searchValue2"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "律师职务",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.formFzr.lawyerPost),
      callback: function($$v) {
        _vm.$set(_vm.formFzr, "lawyerPost", $$v)
      },
      expression: "formFzr.lawyerPost"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addFzr
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogFzrVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-e8e57412"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/user/professional_committee/add/src/subpage2.vue
// module id = 1582
// module chunks = 1